export const BOT_NAME = 'Hana';
